/**
 * ProjectUserRoleEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { ProjectUserRole_TransitionsEntity } from "../ProjectUserRole_TransitionsEntity";
import { ProjectUserRole_BugGroupsEntity } from "../ProjectUserRole_BugGroupsEntity";
import { ProjectUserRightEntity } from "../ProjectUserRightEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { ProjectUserRoleEntity } from "../ProjectUserRoleEntity";
declare global {
    interface EntityTypeMap {
        ProjectUserRole: ProjectUserRoleEntity;
    }
}
export abstract class ProjectUserRoleGeneratedEntity extends BaseEntity {
    public abstract projectUserRoleId: string;
    public abstract templateName: string | null;
    public abstract templateId: string | null;
    public abstract name: string | null;
    public abstract restrictTransitions: boolean;
    public abstract restrictDelete: boolean;
    public abstract restrictRead: boolean;
    public abstract restrictCreateVisit: boolean;
    public abstract readonlyBug: boolean;
    public abstract project: ProjectEntity;
    public abstract readonly transitionsRelations: ReadonlyArray<ProjectUserRole_TransitionsEntity>;
    public abstract readonly bugGroupsRelations: ReadonlyArray<ProjectUserRole_BugGroupsEntity>;
    public abstract readonly attachedRights: ReadonlyArray<ProjectUserRightEntity>;
    public abstract readonly users: ReadonlyArray<ProjectUserEntity>;
}
